import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { IconComponent } from './container/icon.component';

// The whole icon library now ships as one data-driven component: `<app-icon name="…" />`
// (see icon-registry.ts). This module just re-exports it — plus FontAwesomeModule and
// MatTooltipModule so consumers that still use <fa-icon>/matTooltip directly keep working.
@NgModule({
    imports: [
        IconComponent,
        FontAwesomeModule,
        MatTooltipModule,
    ],
    exports: [
        IconComponent,
        FontAwesomeModule,
        MatTooltipModule,
    ],
})
export class IconsModule {}
